<h1 mat-dialog-title rtI18n>Communication Preferences</h1>

<mat-dialog-content class="comm-prefs-body dialog-scroll-shadow">
    @if (saveStatus === ServiceStatus.loading) {
      <div class="save-overlay">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>
    }

    <p class="text-text-blue">
      <small rtI18n>Choose how you'd like to hear from us. You can update these anytime from your profile.</small>
    </p>
    @if (isNativePlatform) {
      <p class="text-text-blue" style="padding-bottom: 4px">
        <small rtI18n>To manage push notifications, go to your phone's Settings > Notifications.</small>
      </p>
    }

    <app-communication-preference-toggles [form]="prefsForm"></app-communication-preference-toggles>

    <div class="d-flex align-items-center gap-2 mb-2 mt-3">
      <i class="icon-info icon-text-blue" style="width: 16px; height: 16px; flex-shrink: 0;"></i>
      <div class="text-text-blue" style="font-size: 12px">
        <i rtI18n>
          By enabling text messaging, you will receive alerts, codes, and updates. Message and data rates
          may apply. Message frequency varies.
        </i>
      </div>
    </div>

    <div class="digest-section">
      <app-communication-digest [form]="prefsForm"></app-communication-digest>
    </div>

    <hr />

    @if (consentSchools.length > 0) {
      <div #consentSection>
        <app-communication-consent-fields
          [schools]="consentSchools"
          [showErrors]="showConsentError"></app-communication-consent-fields>
      </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="comm-prefs-actions">
  @if (consentSchools.length > 0 && !allConsentAnswered()) {
    <a href="javascript:void(0);" class="consent-hint" (click)="scrollToConsent()">
      <i class="icon-info icon-red" style="width: 16px; height: 16px; flex-shrink: 0;"></i>
      <span class="text-alert" rtI18n>Please make a selection for each school.</span>
    </a>
  }
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!canSave()" rtI18n>Save</button>
</mat-dialog-actions>
